import React, { useState, useRef } from 'react';
import './FeedbackWidget.css';

const FeedbackWidget = ({ feedbacks }) => {
  const [showAll, setShowAll] = useState(false);
  const feedbackRef = useRef(null);

  const toggleShowAll = () => {
    setShowAll(!showAll);

    if (showAll) {
        setTimeout(() => {
          feedbackRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }, 0);
    }
  };

  const visibleFeedbacks = showAll ? feedbacks : feedbacks.slice(0, 3);

  return (
    <div className="feedback-widget" ref={feedbackRef}>
      <div className={`feedback-list ${showAll ? 'show-all' : ''}`}>
        {visibleFeedbacks.map((feedback, index) => (
          <div key={index} className="feedback-item">
            <p className="feedback-name"><strong>{feedback.name}</strong></p>
            <p className='feedback-title'><strong>{feedback.title}</strong></p>
            <p className="feedback-content">{feedback.content}</p>
            <p className="feedback-date">{feedback.date}</p>
          </div>
        ))}
      </div>
      <button className="toggle-button" onClick={toggleShowAll}>
        {showAll ? 'Show Less' : 'Show All'}
      </button>
    </div>
  );
};

export default FeedbackWidget;